<p-table [value]="cabReports" (onEditInit)="startEdit($event)" (onEditComplete)="onEditComplete($event)">
  <ng-template pTemplate="header">
    <tr>
      <th class="material-table-cell">Cabinet Name</th>
      <th>Quantity</th>
      <th>WxHxD</th>
      <th>Overall Complexity</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td class="material-table-cell" (click)="clickOnCab(rowData.cabinetName)">
        {{rowData.cabinetName}}
      </td>
      <td>
        {{rowData.quantity}}
      </td>
      <td>
        {{rowData.width | number:'1.2-2'}} x {{rowData.height | number:'1.2-2'}} x {{rowData.depth | number:'1.2-2'}}
      </td>
      <td>
        <!--        {{rowData.material.name}}-->
        {{rowData.overallComplexity | number: '1.2-2'}}
      </td>
    </tr>
  </ng-template>
</p-table>
